import { render } from "./HolidayManagment.vue?vue&type=template&id=3ddb10be&scoped=true"
import script from "./HolidayManagment.vue?vue&type=script&lang=js"
export * from "./HolidayManagment.vue?vue&type=script&lang=js"

import "./HolidayManagment.vue?vue&type=style&index=0&id=3ddb10be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ddb10be"]])

export default __exports__